export default __webpack_public_path__ + "static/media/Ballroll_00072.dd9e3725.png";